document.addEventListener("DOMContentLoaded", function () {
  const drawerContainer = document.getElementById(
    "Details-menu-drawer-container",
  );
  if (drawerContainer) {
    drawerContainer.addEventListener("toggle", function () {
      if (drawerContainer.open) {
        document.documentElement.classList.add("drawer-open");
      } else {
        document.documentElement.classList.remove("drawer-open");
      }
    });
  }

  function setupExclusiveDetails(scope) {
    const detailsList = scope.querySelectorAll(
      "ul.menu-drawer__menu > li > details",
    );
    detailsList.forEach((details) => {
      details.addEventListener("toggle", function (e) {
        if (details.open) {
          detailsList.forEach((other) => {
            if (other !== details) {
              const submenu = other.querySelector(
                ".menu-drawer__submenu.dropdown-submenu",
              );
              if (submenu) {
                submenu.classList.add("animating");
                setTimeout(() => submenu.classList.remove("animating"), 500);
              }
              other.open = false;
            }
          });
        }
        const submenu = details.querySelector(
          ".menu-drawer__submenu.dropdown-submenu",
        );
        if (submenu) {
          submenu.classList.add("animating");
          setTimeout(() => submenu.classList.remove("animating"), 500);
        }
      });
    });
  }
  document
    .querySelectorAll(
      ".menu-drawer__menu.menu-desktop, .menu-drawer__menu.menu-mobile",
    )
    .forEach(setupExclusiveDetails);
});
